import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import MatchedRides from "./OwnerMatchedRides";
import { handlePostRequest } from "../../../services/PostTemplate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import RideStatus from "./OwnerRideStatus";
import ConfirmRides from "./OwnerConfirmRides";
import { Button } from "primereact/button";
import { getSocket, SOCKET_ENDPOINTS } from "../../../services/Socket";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { toast } from "react-toastify";

const RequestStatus = () => {
    const location = useLocation();
    const rowData = location?.state?.rowData || {};
    const dispatch = useDispatch();
    const selectedUserType = useSelector((state) => state.authenticationSlice?.selectedUserType);
    const [flotingBtn, setFlotingBtn] = useState();
    const [passengerNotification, setPassengerNotification] = useState();
    const history = useHistory();
    const socket = getSocket();

    const userId = localStorage.getItem("userId");
    const userType = localStorage.getItem("userType");

    const [matchedList, setMatchedList] = useState([]);
    const [scheduleId, setScheduleId] = useState("");
    const [data, setData] = useState();

    useEffect(() => {
        const handleNewRequest = (data) => {
            try {
                const decryptedResponse = handleDecryptData(data?.cipher);
                console.log(decryptedResponse, "decryptedResponse");
                setPassengerNotification(decryptedResponse);
            } catch (error) {
                console.error("Error while decrypting data:", error);
            }
        };

        socket.on(SOCKET_ENDPOINTS.NEW_REQUEST, handleNewRequest);

        // Cleanup the listener on unmount
        return () => {
            socket.off(SOCKET_ENDPOINTS.NEW_REQUEST, handleNewRequest);
        };
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            socket.emit(SOCKET_ENDPOINTS.NEW_REQUEST, {}, (data) => {
                try {
                    const decryptedResponse = handleDecryptData(data?.cipher);
                    console.log(decryptedResponse, "decryptedResponse newRequest");
                    setPassengerNotification(decryptedResponse);
                } catch (error) {
                    console.error("Error while decrypting data:", error);
                }
            });
        }, 0); // Trigger immediately (or adjust timing if necessary)

        // Cleanup timeout
        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (socket) {
            const passengerRideCancellationListener = (data) => {
                if (selectedUserType === 1) {
                    const encryptedData = {
                        routeId: "678f3e78fb814b824d2bd0e9",
                    };

                    const encryptData = handleEncryptData(encryptedData);
                    socket.emit(
                        SOCKET_ENDPOINTS.GET_ALL_REQUESTS,
                        JSON.stringify(encryptData, (response) => {
                            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
                            console.log(decryptedResponse, "getAllRequests");
                        })
                    );
                    // newpassenger get
                }
                console.log("Passenger Ride Cancellation:", data);
            };

            // Add socket listeners
            // Add socket listeners
            //after cancel hit this sokcet and thenn emit the getAllRequest
            socket.on(SOCKET_ENDPOINTS.NEW_REQUEST, passengerRideCancellationListener);

            console.log("Socket listeners added");

            // Cleanup function to remove listeners when the component unmounts or socket changes
            return () => {
                socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationListener);
                console.log("Socket listeners removed");
            };
        }
    }, [socket]); // Dependency array ensures the effect runs only when `socket` changes

    // if (!location?.state?.rowData) {
    //     history.push('/'); // Redirect to a safe fallback route
    //     return null;
    // }

    const handleMatchedList = async () => {
        try {
            let apiEndpoint = "";
            let payload = "";

            if (selectedUserType == "1") {
                // const apiEndpoint = `api/route/getrequests?routeId=${rowData?._id}`;

                apiEndpoint = "api/route/getrequests";
                payload = {
                    ownerId: userId,
                    routeId: rowData?._id,
                    // page: 1,
                };
            } else {
                apiEndpoint = "api/scheduleride/getmatcheddriver";
                payload = {
                    userId: userId,
                    isScheduled: rowData?.isScheduled,
                    scheduleId: rowData?._id,
                };
            }

            if (apiEndpoint) {
                const response = await dispatch(handlePostRequest(apiEndpoint, payload, true, true));
                setData(response.data);
                setFlotingBtn(response?.data?.data?.status === "started");
                setScheduleId(response?.data?.data?._id || response?.data?.data?.schedule?._id);
                setMatchedList(response?.data?.data?.nearestDriver || response?.data?.matchedPassengers);
            }
        } catch (error) {
            // console.error("Error fetching user vehicle list:", error);
        }
    };

    useEffect(() => {
        const refreshDriverRoutesListener = () => {
            console.log("Driver routes refreshed.");
            handleMatchedList(); // Reset the list
        };

        const passengerRideCancellationListener = (data) => {
            console.log(data, "res data");
            try {
                const decryptedResponse = handleDecryptData(data?.cipher);
                console.log(decryptedResponse, "decryptedResponse");
                handleMatchedList(); // Reset the list
            } catch (error) {
                console.error("Error while decrypting data:", error);
            }
        };

        if (socket) {
            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, refreshDriverRoutesListener);
            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationListener);
        }

        return () => {
            if (socket) {
                socket.off(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, refreshDriverRoutesListener);
                socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationListener);
            }
        };
    }, [socket, handleMatchedList]);

    useEffect(() => {
        if (socket) {
            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                console.log("Refresh driver routes:", response);
                toast.info("Driver routes refreshed");
                handleMatchedList();
            });
            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                console.log("Passenger ride cancellation:", response);
                toast.info("Passenger ride cancelled");
                handleMatchedList();
            });
            socket.on("redirectPassengerToActiveRideListner", (response) => {
                console.log("Redirect passenger to active ride:", response);
                toast.info("Redirecting to active ride");
                history.push("/passenger-ride");
            });
            socket.on("refreshPassengerScheduleListner", (response) => {
                console.log("Refresh passenger schedule:", response);
                toast.info("Passenger schedule refreshed");
                handleMatchedList();
            });
            socket.on("passengerRideCancellationListner", (response) => {
                console.log("Passenger ride cancellation:", response);
                toast.info("Passenger ride cancelled");
                handleMatchedList();
            });
            socket.on("driverCompleteRideListner", (response) => {
                console.log("Driver complete ride:", response);
                toast.info("Driver completed the ride");
                handleMatchedList();
            });
        }

        return () => {
            if (socket) {
                socket.off(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES);
                socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER);
                socket.off("redirectPassengerToActiveRideListner");
                socket.off("refreshPassengerScheduleListner");
                socket.off("passengerRideCancellationListner");
                socket.off("driverCompleteRideListner");
            }
        };
    }, [socket, handleMatchedList]);

    useEffect(() => {
        const refreshDriverRoutesListener = () => {
            console.log("Driver routes refreshed.");
            handleMatchedList(); // Reset the list
        };

        const passengerRideCancellationListener = (data) => {
            console.log(data, "res data");
            try {
                const decryptedResponse = handleDecryptData(data?.cipher);
                console.log(decryptedResponse, "decryptedResponse");
                handleMatchedList(); // Reset the list
            } catch (error) {
                console.error("Error while decrypting data:", error);
            }
        };

        if (socket) {
            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, refreshDriverRoutesListener);
            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationListener);
        }

        return () => {
            if (socket) {
                socket.off(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, refreshDriverRoutesListener);
                socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationListener);
            }
        };
    }, [socket, handleMatchedList]);

    useEffect(() => {
        handleMatchedList();

        if (!location?.state?.rowData) {
            history.push("/schedules"); // Redirect to a safe fallback route
            return null;
        }
    }, []);
    //
    // if (matchedList?.length === 0) {
    //     return <h1>No route Match</h1>;
    // if (matchedList?.length === 0) {
    //     return <h1>No route Match</h1>;
    // }

    const handleStartRoute = () => {
        if (!scheduleId || !userId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            routeId: scheduleId,
            userId: userId,
        };
        const encryptData = handleEncryptData(encryptedData);
        // Emit the socket event
        socket.emit(SOCKET_ENDPOINTS.START, JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility

            if (!decryptedResponse?.activeRide && (!decryptedResponse?.pendingList || decryptedResponse?.pendingList.length == 0)) {
            } else {
                // Redirect to driver-ride with data
                history.push({
                    pathname: "/driver-ride",
                    state: { data: decryptedResponse },
                });
            }
            socket.on(SOCKET_ENDPOINTS.AUTO_COMPLETED_ROUTE, (data) => {});
        });
    };
    return (
        <section>
            <div className="">
                {flotingBtn ? (
                    <Button
                        onClick={() => {
                            handleStartRoute();
                        }}
                        style={{ margin: "auto" }}
                    >
                        Ride
                    </Button>
                ) : (
                    ""
                )}
                <TabView className="p-3 border-200 border-3 border-round">
                    <TabPanel header="Matched">
                        <MatchedRides matchedList={matchedList} scheduleId={scheduleId} data={data} rowData={rowData} />
                    </TabPanel>
                    <TabPanel header="Request">
                        <RideStatus matchedList={matchedList} scheduleId={scheduleId} data={data} rowData={rowData} />
                    </TabPanel>
                    <TabPanel header="Confirmed">
                        <ConfirmRides matchedList={matchedList} scheduleId={scheduleId} data={data} rowData={rowData} />
                    </TabPanel>
                </TabView>
            </div>
        </section>
    );
};

export default RequestStatus;
